export const isAudioProductForm = (code: string) => {
  return code[0] === 'A' || code === 'DL' /* Minnekort */;
};
